<section id="corsi" tabindex="-1"
  [ngClass]="this.router.url === '/home' ? 'date-tabs pt-400 section-padding30' : 'date-tabs pt-400 section-padding30'">
  <ng-container *ngIf="this.router.url === '/home'; else otherLayout">
    <div class="container">
      <div class="row align-items-end justify-content-between">
        <div class="col-lg-6 col-md-9 col-sm-9">
          <div class="section-title">
            <span>Orari corsi</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #otherLayout>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="section-title text-center mb-100">
            <h1>Orari corsi - sede LAURENTINA</h1>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="container-fluid">
    <div class="row justify-content-center mb-10">
      <a href="resources/img/corsi/planning.jpg" download>
        <button class="btn" type="button">Scarica planning</button>
      </a>
    </div>
    <div class="row justify-content-center mb-10">
      <div class="col-lg-11">
        <div class="properties__button">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a *ngFor="let g of giorni; let i = index"
                [ngClass]="giornoSel === i ? 'nav-item nav-link active show' : 'nav-item nav-link'" id="nav-home-tab"
                data-toggle="tab" href="javascript:void(0);" (click)="giornoSel = i" role="tab" aria-controls="nav-home"
                aria-selected="true">{{g.value}}</a>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <div class="tab-content" id="nav-tabContent">
          <div [ngClass]="giornoSel === i ? 'tab-pane fade active show' : 'tab-pane fade'" id="nav-home" role="tabpanel"
            aria-labelledby="nav-home-tab" *ngFor="let g of giorni; let i = index">
            <div class="row">
              <div class="col-12">
                <div class="tab-wrapper">
                  <div class="single-box" *ngFor="let c of orari[i]">
                    <div class="single-caption text-center"> <!--Aggiungere active per vederlo selezionato-->
                      <div class="caption">
                        <span>{{c.pianificazione?.oraInizio}} - {{c.pianificazione?.oraFine}}</span>
                        <h3>{{c.nome}}</h3>
                        <p><span>con</span> {{c.istruttore}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="team-area pb-150 mt-50">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let c of corsi; let i = index">
          <div class="single-team mb-30">
            <div class="team-img">
              <img src="resources/img/corsi/{{c.nomeFoto}}" alt="Foto di {{c.nome}}" class="test">
              <div class="team-caption" id="corso{{c.nome}}">
                <h1 class="pb-30">{{c.nome}}</h1>
                <div class="team-social" *ngIf="c.urlIstruttore">
                  <ul>
                    <li><a href="{{c.urlIstruttore}}"><i class="fab fa-instagram"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>